import React from 'react';

import firebase from '../firebase';
import EditButton from './EditButton';
import ModelFormModal from './modals/ModelFormModal';

const fields = {
  label: {
    type: 'string',
    label: '「その他」の表記',
    placeholder: 'その他',
  },
};

export default function OtherLabelEditButton ({ disclosureSetting, categoryName, currentLabel }) {
  if(disclosureSetting == null) return null;

  return (
    <EditButton
      label={null}
      color="link"
      className="p-0 ml-1 align-baseline"
      icon={<span className="fas fa-pencil-alt" />}
      itemRef={disclosureSetting.ref}
      item={{ label: disclosureSetting.otherLabels?.[categoryName] || '' }}
      FormModal={ModelFormModal}
      formProps={{ title: `「${currentLabel}」の表記を編集`, fields }}
      processValues={({ label }) => ({ [`otherLabels.${categoryName}`]: label || firebase.firestore.FieldValue.delete() })}
    />
  );
};
